module.exports = __webpack_public_path__ + "components/home-header/static/header-1--small@2x-c93e9121b30bb5acd3fa8f0b5d1b3b4a.jpg";